<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex>
        <v-container>
          <v-layout wrap>
            <v-flex
              xs12
              py-5
              text-center
              style="
                font-family: robotobold;
                font-size: 24px;
                letter-spacing: 5px;
              "
            >
              CART
            </v-flex>
            <v-layout justify-center wrap v-if="cart.length > 0">
              <v-flex xs12>
                <v-layout
                  wrap
                  style="font-family: robotoregular; font-size: 14px"
                  py-5
                >
                  <v-flex xs5 sm6>PRODUCT </v-flex>
                  <v-flex class="hidden-md-and-down"
                    ><v-spacer></v-spacer
                  ></v-flex>
                  <v-flex xs3 md2>QUANTITY(KG) </v-flex>
                  <v-flex xs3 text-right>TOTAL </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12><v-divider></v-divider> </v-flex>
              <v-flex xs12 py-3>
                <v-layout wrap v-for="(item, i) in cart" :key="i" py-3>
                  <v-flex xs6>
                    <v-card flat>
                      <v-layout wrap>
                        <v-flex xs3>
                          <v-img :src="mediaURL + item.productId.photos[0]">
                          </v-img>
                        </v-flex>
                        <v-flex xs9 pl-3 pl-lg-5 pt-lg-5>
                          <div style="font-family: robotoregular">
                            {{ item.productId.productName }}
                          </div>
                          <!-- <div
                        style="
                          color: grey;
                          padding-top: 2%;
                          padding-bottom: 2%;
                          font-size: 14px;
                        "
                      >
                        {{item.productId.stockQuantity}} kg
                      </div> -->
                          <div style="font-size: 14px">
                            <span>Rs. {{ item.productId.offerPrice }} </span>
                            <span style="margin-left: 5%; color: grey">
                              <del>Rs. {{ item.productId.price }}</del></span
                            >
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex class="hidden-md-amd-down"
                    ><v-spacer></v-spacer
                  ></v-flex>
                  <v-flex xs3 sm4 md3 lg3 pt-lg-5>
                    <v-layout wrap>
                      <v-layout wrap>
                        <v-flex>
                          <v-btn
                            outlined
                            width="100%"
                            tile
                            @click="edit(item, item.quantity - 1)"
                            :disabled="item.quantity <= 1"
                          >
                            <v-icon :ripple="false" depressed>
                              mdi-minus
                            </v-icon></v-btn
                          >
                        </v-flex>
                        <v-flex>
                          <v-btn outlined width="100%" tile
                            >{{ item.quantity }}kg</v-btn
                          >
                        </v-flex>
                        <v-flex>
                          <v-btn
                            outlined
                            width="100%"
                            tile
                            @click="edit(item, item.quantity + 1)"
                            :disabled="
                              item.quantity == item.productId.stockQuantity
                            "
                          >
                            <v-icon :ripple="false" depressed>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-flex
                        xs9
                        lg12
                        text-center
                        py-3
                        @click="deleteItem(item)"
                        style="
                          color: #7b7b7b;
                          text-decoration-line: underline;
                          font-size: 13px;
                          cursor: pointer;
                        "
                      >
                        REMOVE
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    pt-lg-5
                    xs3
                    sm2
                    md3
                    text-right
                    style="font-family: robotobold"
                    >Rs. {{ item.amount }}
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 py-3>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 text-right>
                <span style="font: 12px robotoregular"> TOTAL </span>
                <span style="padding-left: 5%; font: 25px robotomedium">
                  Rs. {{ tot.total }}
                </span>
              </v-flex>
              <v-flex
                xs12
                text-right
                style="color: #888888; font-family: robotoregular"
                py-3
              >
                Shipping & taxes calculated at checkout
              </v-flex>
              <v-flex xs12 text-right pb-sm-12 pt-lg-1>
                <router-link
                  style="text-decoration: none; color: white"
                  :to="{ name: 'cartshipping' }"
                >
                  <v-btn
                    class="hidden-sm-and-down"
                    tile
                    color="#FEBD08"
                    elevatio="0"
                    width="15%"
                    style="color: white"
                  >
                    <span>CHECK OUT</span>
                  </v-btn>
                </router-link>
                <router-link
                  style="text-decoration: none; color: white"
                  :to="{ name: 'cartshipping' }"
                >
                  <v-btn
                    class="hidden-md-and-up"
                    tile
                    color="#FEBD08"
                    elevatio="0"
                    :style="
                      $vuetify.breakpoint.name == 'xs'
                        ? 'width:100%'
                        : 'width:50%'
                    "
                  >
                    <span>CHECK OUT</span>
                  </v-btn>
                </router-link>
              </v-flex>
              <v-flex xs12 style="height: 12vh" class="hidden-sm-and-down">
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap v-else>
              <v-flex xs12 text-center py-5>
                <span style="font-family: robotoregular">No data found...</span>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      msg: "",
      timeout: 5000,
      snackbar: false,
      appLoading: false,
      ServerError: false,
      cart: [],
      tot: [],
      qty: 1,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/cart/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cart;
          this.tot = response.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit(val, qty) {
      this.appLoading = true;
      var user = {};
      user["quantity"] = qty;
      user["id"] = val._id;
      axios({
        method: "POST",
        url: "/cart/edit",
        data: user,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Cart Update Successully";
            this.snackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(r) {
      axios({
        url: "/cart/remove/" + r._id,
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.snackbar = true;
            this.$store.commit("changeCart", response.data.cart_length);
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>